import { Controller } from "@hotwired/stimulus"

// the current 'tooltip' controller doesn't properly center the arrow
export default class extends Controller {
  static values = {
    placement: { type: String, default: "right" },
    trigger: { type: String, default: "hover" },
    html: Boolean
  }

  connect() {
    $(this.element).tooltip({
      placement: this.placementValue,
      container: "body",
      trigger: this.triggerValue,
      html: this.htmlValue
    })
  }
}
